import { useLazyQuery } from '@apollo/client';
import { gql } from '__generated__';
import classNames from 'classnames';
import { FC, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useMatch } from 'react-router-dom';

import checkIcon from 'media/icons/check.svg';

import theme from './theme.module.scss';

const GET_EMPLOYEE_QUERY = gql(`
  query GetUserTabs($id: ID!) {
    user(id: $id) {
      id
      employee {
        id
      }
    }
  }
`);

const tabs = [
  { name: 'Basic Information', url: 'basic-information' },
  { name: 'Employment', url: 'employee-information' },
];

const EmployeeTabs: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { departmentId, userId } = useParams<{ departmentId: string; userId: string }>();

  const basePathmatch = useMatch(`/create/departments/${departmentId}/user`);

  const [getEmployee, { data }] = useLazyQuery(GET_EMPLOYEE_QUERY);

  useEffect(() => {
    if (!userId) return;

    getEmployee({ variables: { id: userId } });
  }, [userId, getEmployee]);

  function isPathActive(path: string): boolean {
    // Show BasicInfo tab as active if the base path is matched
    if (basePathmatch && path === 'basic-information') {
      return true;
    }

    return location.pathname.includes(path);
  }

  function isStepComplete(path: string): boolean {
    switch (true) {
      case path === 'basic-information' && !!data?.user:
        return true;
      case path === 'career' && !!data?.user?.employee:
        return true;
      default:
        return false;
    }
  }

  return (
    <div className={theme.tabsContainer}>
      {tabs.map(tab => (
        <div
          key={tab.name}
          className={classNames(
            theme.tab,
            isPathActive(tab.url) ? theme.selected : undefined,
            userId || isPathActive(tab.url) ? undefined : theme.disabled
          )}
          onClick={() =>
            userId
              ? navigate(`/create/departments/${departmentId}/user/${userId}/${tab.url}`)
              : navigate(`/create/departments/${departmentId}/user`)
          }
        >
          {tab.name}
          {isStepComplete(tab.url) ? (
            <img src={checkIcon} alt={'check'} width={20} height={20} />
          ) : null}
        </div>
      ))}
    </div>
  );
};

export default EmployeeTabs;
